// AI 모델 설정 화면 고정 글(계약 §10: 「사용 모델」 표·미리보기 문장은 화면이 가진다)

export const STYLES = [
    { code: "professional", label: "전문적이고 정확한 답변", preview: "영수증 용지 요청을 접수해 드리겠습니다. 필요한 수량을 말씀해 주시면 담당자가 배송 일정을 안내드립니다. (1박스 = 50롤)" },
    { code: "friendly", label: "친근하고 대화형 답변", preview: "용지가 다 떨어지셨군요! 몇 박스 필요하세요? 바로 접수해 드릴게요. 1박스에 50롤이에요." },
    { code: "concise", label: "간결하고 핵심적인 답변", preview: "수량을 알려주세요. (1박스 = 50롤) 접수 후 담당자가 배송 일정을 안내합니다." },
];

export const OPTIONS = [
    { key: "block_inappropriate", title: "부적절한 질문 차단", sub: "욕설, 스팸은 답하지 않고 안내 문구만 보여줍니다" },
    { key: "restrict_non_tech", title: "기술 외 문의 제한", sub: "포스·키오스크·결제와 관계없는 질문은 정중히 거절합니다" },
    { key: "fast_response_mode", title: "빠른 응답 모드", sub: "FAQ에 있는 질문은 문서 검색 없이 바로 답합니다" },
    { key: "suggest_agent_handoff", title: "상담원 연결 추천", sub: "두 번 안내해도 해결되지 않으면 문의 접수를 먼저 제안합니다" },
];

// 행이 없을 때(404) 쓰는 값 — 백엔드 컬럼 기본값과 같다
export const DEFAULT_NAME = "gpt-4o-mini";
export const DEFAULTS = {
    response_style: "professional", block_inappropriate: true, restrict_non_tech: true,
    fast_response_mode: true, suggest_agent_handoff: true,
};

export const pickForm = (m) => {
    const src = m || DEFAULTS;
    return Object.fromEntries(Object.keys(DEFAULTS).map((k) => [k, src[k] ?? DEFAULTS[k]]));
};

const trim1 = (n) => String(Math.round(n * 10) / 10);
export const pct = (r) => (r === null || r === undefined ? "—" : `${trim1(r * 100)}%`);
export const sec = (s) => (s === null || s === undefined ? "—" : `${trim1(s)}초`);
export const cnt = (n) => (n === null || n === undefined ? "—" : `${n}건`);

export const stamp = (d = new Date()) => {
    const p = (n) => String(n).padStart(2, "0");
    return `${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}`;
};
